import { request } from "@insite/client-framework/Services/ApiService";

export function customCreateUsForm(body: any, emailTo: string) {
    return request(
        `api/v1/CustomContactUs/Submit?EmailTo=${emailTo}`,
        "POST",
        { "Content-Type": "application/json" },
        JSON.stringify(body) as any,
    );
}

export function customContactUsForm(body: any, emailTo: string) {
    return request(`api/v1/rqi`, "POST", { "Content-Type": "application/json" }, JSON.stringify(body) as any);
}

export function customSurveyForm(body: any) {
    return request(`api/v1/survey`, "POST", { "Content-Type": "application/json" }, JSON.stringify(body) as any);
}
